import React from 'react'
import { Bleed, Button, DangerButton, Row, Separator } from '@fs/zion-ui'
import { useCoverages, useCheckboxes } from '../../hooks'

import styles from '../../groupData/GroupData.styles'
import transl from '../../groupData/GroupData.transl'

export default function ImageOrganizeFooter() {
  const { setAllCoverageCheckboxes, deleteSelectedCoverageCheckboxes } = useCoverages()
  const { deleteSelectedCreatorCheckboxes, resetCreatorCheckboxes } = useCheckboxes()

  const handleDelete = () => {
    deleteSelectedCoverageCheckboxes()
    deleteSelectedCreatorCheckboxes()
  }

  const handleCancel = () => {
    setAllCoverageCheckboxes(false)
    resetCreatorCheckboxes()
  }

  return (
    <>
      <Separator size="xxl" />
      <Bleed sides>
        <div css={styles.infoSheetFooter}>
          <Row guttersY="none" alignX="end">
            <Button onClick={handleCancel}>{transl.cancelButtonText()}</Button>
            <DangerButton onClick={handleDelete}>{transl.removeSelected()}</DangerButton>
          </Row>
        </div>
      </Bleed>
    </>
  )
}
